module.exports = __webpack_public_path__ + "static/media/norwegian.08c698dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients/norwegian.svg
// module id = 94
// module chunks = 3